module.exports = __webpack_public_path__ + "static/media/plus_blue.2e80e0b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plus_blue.svg
// module id = 1436
// module chunks = 0